import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ChangePasswordGuard } from "src/app/core/guard/change-password.guard";
import { RoleGuard } from "src/app/core/guard/role.guard";
import { ProfileAboutUsComponent } from "./page/profile-about-us/profile-about-us.component";
import { ProfileAccountComponent } from "./page/profile-account/profile-account.component";
import { ProfileAchievementsComponent } from "./page/profile-achievements/profile-achievements.component";
import { ProfileBillingComponent } from "./page/profile-billing/profile-billing.component";
import { ProfileCertificatesComponent } from "./page/profile-certificates/profile-certificates.component";
import { ProfileChangeEmailComponent } from "./page/profile-change-email/profile-change-email.component";
import { ProfileChangePasswordComponent } from "./page/profile-change-password/profile-change-password.component";
import { ProfileContactUsComponent } from "./page/profile-contact-us/profile-contact-us.component";
import { ProfileDocumentsComponent } from "./page/profile-documents/profile-documents.component";
import { ProfileFaqComponent } from "./page/profile-faq/profile-faq.component";
import { ProfileInterestsComponent } from "./page/profile-interests/profile-interests.component";
import { ProfileLeaderboardComponent } from "./page/profile-leaderboard/profile-leaderboard.component";
import { ProfilePaymentMethodsComponent } from "./page/profile-payment-methods/profile-payment-methods.component";
import { ProfilePreferencesComponent } from "./page/profile-preferences/profile-preferences.component";
import { ProfilePrivacyPolicyComponent } from "./page/profile-privacy-policy/profile-privacy-policy.component";
import { ProfileRecurrenceSubscriptionsComponent } from "./page/profile-recurrence-subscriptions/profile-recurrence-subscriptions.component";
import { ProfileReviewListComponent } from "./page/profile-review-list/profile-review-list.component";
import { ProfileSkillsComponent } from "./page/profile-skills/profile-skills.component";
import { ProfileUseTermsComponent } from "./page/profile-use-terms/profile-use-terms.component";
import { ProfileComponent } from "./page/profile.component";

export const routes: Routes = [
    {
        path: "",
        component: ProfileComponent,
        children: [
            {
                path: "account",
                component: ProfileAccountComponent
            },
            {
                path: "documents",
                component: ProfileDocumentsComponent
            },
            {
                path: "achievements",
                component: ProfileAchievementsComponent
            },
            {
                path: "change-email",
                component: ProfileChangeEmailComponent
            },
            {
                path: "change-password",
                canActivate: [ChangePasswordGuard],
                component: ProfileChangePasswordComponent
            },
            {
                path: "preferences",
                component: ProfilePreferencesComponent
            },
            {
                path: "interests",
                component: ProfileInterestsComponent
            },
            {
                path: "skills",
                component: ProfileSkillsComponent
            },
            {
                path: "faq",
                component: ProfileFaqComponent
            },
            {
                path: "contact-us",
                component: ProfileContactUsComponent
            },
            {
                path: "use-terms",
                component: ProfileUseTermsComponent
            },
            {
                path: "privacy-policy",
                component: ProfilePrivacyPolicyComponent
            },
            {
                path: "about-us",
                component: ProfileAboutUsComponent
            },
            {
                path: "billing",
                component: ProfileBillingComponent
            },
            {
                path: "recurrence-subscriptions",
                component: ProfileRecurrenceSubscriptionsComponent
            },
            {
                path: "payment-methods",
                component: ProfilePaymentMethodsComponent
            },
            {
                path: "reviewer",
                canActivate: [RoleGuard],
                data: {
                    expectedRole: "Reviewer"
                },
                component: ProfileReviewListComponent
            },
            {
                path: "leaderboard",
                component: ProfileLeaderboardComponent
            },
            {
                path: "certificates",
                component: ProfileCertificatesComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProfileRoutingModule {}
